import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 14 16",
    }}
    fill="#2c3e43"
    viewBox="0 0 14 16"
    {...props}
  >
    <path
      d="M12.1 3.5c-.1-.1-.2-.1-.3-.2-.3-.1-.6-.3-.8-.6-.6-.7-.8-1.4-.9-1.8-.1-.4 0-.7 0-.7H7.4V11c0 .4-.1.7-.3 1-.2.3-.5.6-.8.8-.3.2-.7.3-1.1.3-1.2 0-2.3-1-2.3-2.3 0-1.3 1-2.3 2.3-2.3.2 0 .5 0 .7.1V5.9c-.7-.1-1.4 0-2 .2-.8.2-1.4.6-1.9 1S1.1 8 .8 8.5c-.1.2-.5 1-.6 2.2 0 .7.2 1.5.3 1.8.1.2.3.8.7 1.3.4.5.8.9 1.2 1.2 1.3.9 2.7.8 2.7.8.2 0 1.1 0 2-.4 1-.5 1.6-1.2 1.6-1.2.4-.4.7-.9.9-1.5.2-.6.3-1.4.3-1.7V5.4l.5.3s.6.4 1.6.7c.7.2 1.6.2 1.6.2V4c-.2 0-.9-.1-1.5-.5z"
    />
  </svg>
)
export default SvgComponent